import { render } from "./GameAddHeader.vue?vue&type=template&id=35274a85"
import script from "./GameAddHeader.vue?vue&type=script&lang=js"
export * from "./GameAddHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__